import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AuthUsersPanel = ({ data, loading, onRefresh, lastUpdated }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date?.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-md">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
              <Icon name="Database" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">auth.users Table</h3>
              <p className="text-xs text-muted-foreground">Authentication system data</p>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            iconName="RefreshCw"
            onClick={onRefresh}
            disabled={loading}
            className={loading ? 'animate-spin' : ''}
          >
            Refresh
          </Button>
        </div>
      </div>

      <div className="p-4 md:p-6">
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        ) : data ? (
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">User ID</label>
                <p className="text-sm font-mono text-foreground bg-muted p-2 rounded break-all">{data?.id}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Email</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{data?.email}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Created At</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{formatDate(data?.created_at)}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Updated At</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{formatDate(data?.updated_at)}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Last Sign In</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{formatDate(data?.last_sign_in_at)}</p>
              </div>
            </div>

            <div className="space-y-2 mt-4">
              <label className="text-xs font-medium text-muted-foreground">User Metadata (raw_user_meta_data)</label>
              <pre className="text-xs font-mono text-foreground bg-muted p-3 rounded overflow-x-auto max-h-40 overflow-y-auto">
                {JSON.stringify(data?.raw_user_meta_data, null, 2)}
              </pre>
            </div>

            <div className="space-y-2">
              <label className="text-xs font-medium text-muted-foreground">App Metadata (raw_app_meta_data)</label>
              <pre className="text-xs font-mono text-foreground bg-muted p-3 rounded overflow-x-auto max-h-40 overflow-y-auto">
                {JSON.stringify(data?.raw_app_meta_data, null, 2)}
              </pre>
            </div>

            {lastUpdated && (
              <div className="flex items-center gap-2 text-xs text-muted-foreground mt-4 pt-4 border-t border-border">
                <Icon name="Clock" size={12} />
                <span>Last updated: {formatDate(lastUpdated)}</span>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-8 text-muted-foreground">
            <Icon name="AlertCircle" size={32} className="mx-auto mb-2 opacity-50" />
            <p>No data available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthUsersPanel;